<template>
  <div>
    <lvHeader></lvHeader>
    <!-- 交易中心 -->
    <div class="tradingCenter w">
      <div class="tradingCenter_title navOne">
        <div class="trade"> <img src="../assets/images/20200303_jy.png" alt=""> 交易 </div>
        <!-- 导航 -->
        <el-menu :default-active="activePath" class="el-menu-demo" mode="horizontal">
          <el-menu-item index="/myAssets">我的资产</el-menu-item>
          <el-menu-item index="/myDiagnosis" @click="dialogVisable = true">我的诊断</el-menu-item>
          <el-menu-item index="/myChoice" @click="dialogVisable = true">我的自选</el-menu-item>
          <el-menu-item index="/coupon" @click="dialogVisable = true">优惠券</el-menu-item>
          <el-menu-item index="/member" @click="dialogVisable = true">点财通会员</el-menu-item>
          <el-menu-item index="/accountManagement" @click="dialogVisable = true">账户管理</el-menu-item>
          <el-menu-item index="/messageCenter" @click="dialogVisable = true">消息中心</el-menu-item>
        </el-menu>
      </div>
      <div class="tradingCenter_con">
        <!-- 我的资产 -->
        <div class="myassets w">
          <!-- 资产分布 -->
          <div class="assets">
            <div class="assets_con">
              <!-- 我的资产 -->
              <div class="distribution fl">
                <span class="distribution_words">资产分布</span>
                <img src="../assets/images/echarts.png" alt="" class="noData">
                <ul class="distribution_detail">
                  <li> 我的总资产(元)： <span>0.00</span> </li>
                  <li> 昨日收益(元)： <span>0.00</span> </li>
                  <li> 持有收益(元)： <span>0.00</span> </li>
                  <li> 累计收益(元)： <span>0.00</span> </li>
                </ul>
              </div>
              <div class="dottedLine fl"></div>
              <!-- 卡券 -->
              <div class="coupon fr">
                <div class="couponCard btnOne">
                  <p class="coupon1">卡券</p>
                  <p class="coupon2">您有<span class="colorBlue"> 0 </span>张卡券可以使用</p>
                  <el-button type="simple" @click="dialogVisable = true">查看详情</el-button>
                </div>
                <div class="couponCard btnOne" style="margin-top: 10px;position: relative;">
                  <p class="coupon1">点财通会员</p>
                  <ul class="coupon2">
                    <li>可用积分：<span class="colorBlue"> 0 </span></li>
                    <li>会员截止：<span class="colorBlue">--</span></li>

                  </ul>

                  <el-button type="simple" @click="dialogVisable = true">续费</el-button>
                  <el-button type="simple" @click="dialogVisable = true">积分记录</el-button>
                  <el-button type="simple" @click="dialogVisable = true">积分兑换</el-button>
                </div>
              </div>
            </div>
            <div class="assets_foot notice">
              <img class="hornImg" src="../assets/images/20210303_lb.png" alt="">
              <p class="hornTit">公告：</p>
              <div class="hornWords">
                <span v-show="!hornShow">暂无公告</span>
                <vue-seamless-scroll v-show="hornShow" :data="listData" :class-option="classOption" class="warp">
                  <ul class="ul-item">
                    <li class="li-item">{{hornText}}</li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>

          </div>
          <!-- 基金模块 -->
          <ul class="fundModule" id="fundModule">
            <li class="mod active">
              <div class="boxTitle">恒宝宝</div>
              <p class="fundTol"> 总资产(元) <span>0.00</span></p>
              <ul class="profitBox">
                <li> 七日年化收益率： <span>0.00</span> </li>
                <li> 昨日收益(元)： <span>0.00</span> </li>
                <li> 累计收益(元)： <span>0.00</span> </li>
              </ul>
              <!-- 操作 -->
              <div class="fundOperation btnTwo">
                <el-button type="primary" @click="dialogVisable = true">充值</el-button>
                <el-button type="primary" @click="dialogVisable = true">定投</el-button>
                <el-button type="primary" @click="dialogVisable = true">提现</el-button>
                <el-button type="primary" @click="dialogVisable = true">记录</el-button>
              </div>
              <!-- 展开详情 -->
              <span class="open" id="open" @click="hbbClick">
                <span v-show="flag1 == false"> 展开详情 </span>
                <i :class="flag1 == true?'el-icon-arrow-up' : 'el-icon-arrow-down'  "></i>
              </span>
            </li>
            <li class="mod">
              <div class="boxTitle">基金组合</div>
              <p class="fundTol"> 总资产(元) <span>0.00</span></p>
              <ul class="profitBox">
                <li> 昨日收益(元)： <span>0.00</span> </li>
                <li> 持有收益(元)： <span>0.00</span> </li>
                <li> 累计收益(元)： <span>0.00</span> </li>
              </ul>
              <!-- 操作 -->
              <div class="fundOperation btnTwo">
                <el-button type="primary" @click="dialogVisable = true">买入</el-button>
                <el-button type="primary" @click="dialogVisable = true">记录</el-button>
              </div>
              <!-- 展开详情 -->
              <span class="open" @click="zhClick">
                <span v-show="flag2"> 展开详情 </span>
                <i :class="flag2 == true? 'el-icon-arrow-down':'el-icon-arrow-up'"></i>
              </span>
            </li>
            <li class="mod">
              <div class="boxTitle">公募基金</div>
              <p class="fundTol"> 总资产(元) <span>0.00</span></p>
              <ul class="profitBox">
                <li> 昨日收益(元)： <span>0.00</span> </li>
                <li> 持有收益(元)： <span>0.00</span> </li>
                <li> 累计收益(元)： <span>0.00</span> </li>
              </ul>
              <!-- 操作 -->
              <div class="fundOperation btnTwo">
                <el-button type="primary" @click="dialogVisable = true">买入</el-button>
                <el-button type="primary" style="width: 70px;" @click="dialogVisable = true">定投管理</el-button>
                <el-button type="primary" @click="dialogVisable = true">记录</el-button>
              </div>
              <!-- 展开详情 -->
              <span class="open" @click="gmClick">
                <span v-show="flag3"> 展开详情 </span>
                <i :class="flag3 == true? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </li>
            <li class="mod">
              <div class="boxTitle">私募基金</div>
              <p class="fundTol"> 总资产(元) <span>0.00</span></p>
              <ul class="profitBox">
                <li> 持有产品数量： <span>0.00</span> </li>
                <li> 最新净值日期： <span>0.00</span> </li>
                <li> 持有收益(元)： <span>0.00</span> </li>
              </ul>
              <!-- 操作 -->
              <div class="fundOperation btnTwo">
                <el-button type="primary">买入</el-button>
                <el-button type="primary">记录</el-button>
              </div>
              <!-- 展开详情 -->
              <span class="open" @click="smClick">
                <span v-show="flag4"> 展开详情 </span>
                <i :class="flag4 == true? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </li>
          </ul>
          <!-- 基金模块内容 -->
          <div class="fundModuleCon">
            <div v-show="hbbShow" class="common-box" style="margin-top: 10px;border-top: 1px solid #c8c8c8;">
              <el-row class="row-one">
                <span class="row-one-title">恒宝宝资产信息</span>
              </el-row>
              <ul class="message_record clearfix">
                <li>
                  可用金额 (元)：
                  <span>0.00</span>
                </li>
                <li>
                  在途金额 (元)：
                  <span>0.00</span>
                </li>
                <li>
                  近一月平均收益率：
                  <span>0.00</span>
                </li>
              </ul>
              <!-- 图表 -->
              <!-- <div class="hbbEcharts">
        <div id="hbbsyl" v-loading="echartsLoading" element-loading-text="加载中..." style="width:1148px;height:320px"> </div>
      </div> -->
              <!-- 月收益 -->
              <div class="hbbYear">
                <!-- 月表格 -->
                <el-table class="table-one" :data="hbbMonthRatetableData" border style="width: 100%;margin-top:20px;">
                  <el-table-column prop="navdate1" label="日期">
                  </el-table-column>
                  <el-table-column prop="growthrate1" label="七日年化收益率">
                  </el-table-column>
                  <el-table-column prop="navdate2" label="日期">
                  </el-table-column>
                  <el-table-column prop="growthrate2" label="七日年化收益率">
                  </el-table-column>
                  <el-table-column prop="navdate3" label="日期">
                  </el-table-column>
                  <el-table-column prop="growthrate3" label="七日年化收益率">
                  </el-table-column>
                  <el-table-column prop="navdate4" label="日期">
                  </el-table-column>
                  <el-table-column prop="growthrate4" label="七日年化收益率">
                  </el-table-column>
                </el-table>
              </div>
              <!-- 累计收益 -->
              <div class="hbbCumulative" style="margin-top:30px;">
                <ul class="message_record clearfix">
                  <li>
                    估算累计收益 (元)：
                    <span>0.00</span>
                  </li>
                  <li>
                    已结转收益 (元)：
                    <span>0.00</span>
                  </li>
                  <li>
                    估算未付收益 (元)：
                    <span>0.00</span>
                  </li>
                </ul>
                <!-- 累计收益表格 -->
                <el-table class="table-one" style="width: 100%;" :data="hbbMonthRatetableData" border>
                  <el-table-column prop="transactiondate1" label="日期">
                  </el-table-column>
                  <el-table-column prop="amount1" label="每日收益 ( 元 )">
                  </el-table-column>
                  <el-table-column prop="transactiondate2" label="日期">
                  </el-table-column>
                  <el-table-column prop="amount2" label="每日收益 ( 元 )">
                  </el-table-column>
                  <el-table-column prop="transactiondate3" label="日期">
                  </el-table-column>
                  <el-table-column prop="amount3" label="每日收益 ( 元 )">
                  </el-table-column>
                  <el-table-column prop="transactiondate4" label="日期">
                  </el-table-column>
                  <el-table-column prop="amount4" label="每日收益 ( 元 )">
                  </el-table-column>
                </el-table>

              </div>
            </div>
            <div v-show="zhShow" class="common-box margin-t10">
              <el-row class="row-one">
                <span class="row-one-title">组合资产信息</span>
              </el-row>
              <el-radio-group class="radio-single-btn margin-t20" v-model="radio" size="medium">
                <el-radio-button :label="1">持仓信息 ( 0 )</el-radio-button>
                <el-radio-button :label="2">确认中 ( 0 )</el-radio-button>
              </el-radio-group>
              <!-- 持仓信息 -->
              <el-table v-if="radio==1" key="holdFundTable" class="table-single margin-t20" :data="hbbMonthRatetableData" ref="holdFundTableRef" style="width: 100%">
                <el-table-column label="组合名称" prop="funddesc" width="170">
                </el-table-column>
                <el-table-column label="更新日期" prop="navdate">
                </el-table-column>
                <el-table-column label="当前市值" prop="mktvalue">
                </el-table-column>
                <el-table-column label="昨日收益" prop="yestdayprofit">
                </el-table-column>
                <el-table-column label="持有收益" prop="phaseprofit">
                </el-table-column>
                <el-table-column label="仓位差异" prop="ChaYi">
                </el-table-column>
                <el-table-column label="操作" prop="tap" width="200">
                </el-table-column>
                <el-table-column label="组合持仓" prop="cczh">
                </el-table-column>
                <el-table-column width="100">
                </el-table-column>
                <!-- 展开 -->
                <el-table-column type="expand" width="1">
                </el-table-column>
              </el-table>
              <!-- 确认中 -->
              <el-table v-else-if="radio==2" key="confirmTable" class="table-single  margin-t20" :data="hbbMonthRatetableData" ref="confirmTableRef" style="width: 100%">
                <el-table-column label="申请时间" prop="time" width="180">
                </el-table-column>
                <el-table-column label="组合名称" prop="combinationcode" width="180">
                </el-table-column>
                <el-table-column label="交易类型" prop="type">
                </el-table-column>
                <el-table-column label="交易金额" prop="investamount">
                </el-table-column>
                <el-table-column label="实际金额" prop="moneyasset">
                </el-table-column>
                <el-table-column label="关联账户" prop="account" width="183">
                </el-table-column>
                <el-table-column label="交易状态">
                </el-table-column>
                <el-table-column label="操作" width="165">
                </el-table-column>
              </el-table>
            </div>
            <div v-show="gmShow" class="common-box margin-t10" style="margin-bottom: 0">
              <el-row class="row-one">
                <span class="row-one-title">公募基金资产信息</span>
              </el-row>
              <el-radio-group class="radio-single-btn margin-t20" v-model="bankCardValue" size="medium">
                <el-radio-button label="1">持仓信息( 0 )</el-radio-button>
              </el-radio-group>
              <el-row class=" margin-t20">
                <el-col :span="4">
                  <!-- 选择框 -->
                  <el-select v-model="bankCardValue" placeholder="请选择银行卡" style="margin-right: 30px;">
                    <el-option label="全部银行卡" value="1"> </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="marketValue" placeholder="请选择排序方式" style="margin-right: 37px;">
                    <el-option label="当前市值排序" value="1"> </el-option>
                    <el-option label="持有收益排序" value="2"> </el-option>
                    <el-option label="当前代码排序" value="3"> </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5">
                  <el-input class="inputOne" placeholder="基金代码/名称" suffix-icon="el-input__icon el-icon-search" v-model="searchInput">
                  </el-input>
                </el-col>

              </el-row>
              <!-- 表格 -->
              <el-table :data="hbbMonthRatetableData" class="table-single  margin-t20 loding-one" style="width: 100%;">
                <el-table-column type="index" width="30">
                </el-table-column>
                <el-table-column prop="fundcode" label="基金代码" width="80">
                </el-table-column>
                <el-table-column prop="fundcodename" label="基金名称" width="100">
                </el-table-column>
                <el-table-column prop="nav" label="最新净值" width="80">
                </el-table-column>
                <el-table-column prop="navdate" label="更新日期" width="95">
                </el-table-column>
                <el-table-column prop="fundvol" label="基金份额">
                </el-table-column>
                <el-table-column prop="availbal" label="可用份额">
                </el-table-column>
                <el-table-column prop="mktvalue" label="当前市值">
                </el-table-column>
                <el-table-column prop="yestdayprofit" label="昨日收益">
                </el-table-column>
                <el-table-column prop="phaseprofit" label="持有收益">
                </el-table-column>
                <el-table-column prop="syl" label="持有收益率" width="90">
                </el-table-column>
                <el-table-column prop="operate" label="操作" width="260">
                </el-table-column>

              </el-table>
            </div>
            <div v-show="smShow" class="common-box margin-t10">
              <el-row class="row-one">
                <span class="row-one-title">私募基金资产信息</span>
              </el-row>
              <el-radio-group class="radio-single-btn margin-t20" v-model="radio" size="medium">
                <el-radio-button label="1">持仓信息( 0 )</el-radio-button>
                <el-radio-button label="2">确认中( 0 )</el-radio-button>
              </el-radio-group>
              <!-- 持仓信息 -->
              <el-table v-show="radio==1" class="table-single margin-t20" :data="hbbMonthRatetableData" ref="holdFundTableRef" style="width: 100%">
                <el-table-column label="基金名称" prop="sname" width="240">
                </el-table-column>
                <el-table-column label="最新净值(仅供参考)" prop="currnav" width="150">
                </el-table-column>
                <el-table-column label="净值日期" prop="navdate">
                </el-table-column>
                <el-table-column label="当前市值" prop="curramount">
                </el-table-column>
                <el-table-column label="净购买金额" prop="costamount">
                </el-table-column>
                <el-table-column label="确认份额" prop="amountvol">
                </el-table-column>
                <el-table-column label="持有收益(元)" prop="holdIncome">
                </el-table-column>
                <el-table-column label="操作" prop="tap">
                </el-table-column>
              </el-table>
              <!-- 确认中 -->
              <el-table v-show="radio==2" class="table-single margin-t20" :data="hbbMonthRatetableData" ref="confirmTableRef" style="width: 100%">
                <el-table-column label="基金名称" prop="fundName" width="150">
                </el-table-column>
                <el-table-column label="交易类型" prop="businessType">
                </el-table-column>
                <el-table-column label="申请日期" prop="AddDate">
                </el-table-column>
                <el-table-column label="净购买金额" prop="Amount">
                </el-table-column>
                <el-table-column label="认/申购费" prop="Charge">
                </el-table-column>
                <el-table-column label="汇款银行卡" prop="BankName">
                </el-table-column>
                <el-table-column label="最近开放日" prop="time">
                </el-table-column>
                <el-table-column label="交易状态" prop="orderStatus">
                </el-table-column>
                <el-table-column label="操作">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lvFooter></lvFooter>
    <!-- 弹框 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :close-on-click-modal="false">
      <img src="https://trade.myfund.com/kfit/img/new20200910/20200908_bank.png" alt="" style="width:80px;height:56px;margin-left:118px;">
      <div class="margin-t30">
        <!-- $router.push({name:'openAccount'}) -->
        <el-button type="cancel" style="width:154px" @click="dialogVisable = false">先浏览看看</el-button>
        <el-button type="normal1" @click="perfect">完善交易信息</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import lvHeader from '@/components/lv-header/lv-header.vue';
import lvFooter from '@/components/lv-footer/lv-footer.vue';
// 滚动
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "index",
  components: {
    lvHeader,
    lvFooter,
    vueSeamlessScroll,
  },
  data () {
    return {
      //滚动
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        limitMoveNum: 1,
        direction: 2,
      },
      dialogVisable: true,
      hbbMonthRatetableData: [],
      // 四模块显示
      hbbShow: true,
      zhShow: false,
      gmShow: false,
      smShow: false,
      flag1: true,
      flag2: true,
      flag3: true,
      flag4: true,
      activePath: '/myAssets',
      bankCardValue: '1',
      marketValue: '1',
      searchInput: '',
      // 公告
      hornText: '',
      length: 0,
      hornShow: true,
      // 
      radio: 1,
    }
  },
  created () {
    document.title = '开放式基金网上交易系统'
  },
  mounted () {
    $('#fundModule>li').click(function () {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    })
    this.getNotice()
  },
  methods: {
    // 展开
    hbbClick () {
      this.hbbShow = !this.hbbShow
      this.flag1 = !this.flag1
      this.flag2 = true
      this.flag3 = true
      this.flag4 = true
      this.zhShow = false
      this.gmShow = false
      this.smShow = false
    },
    zhClick () {
      this.zhShow = !this.zhShow
      this.flag2 = !this.flag2
      this.flag1 = false
      this.flag3 = true
      this.flag4 = true
      this.hbbShow = false
      this.gmShow = false
      this.smShow = false
    },
    gmClick () {
      this.gmShow = !this.gmShow
      this.flag3 = !this.flag3
      this.flag2 = true
      this.flag1 = false
      this.flag4 = true
      this.hbbShow = false
      this.zhShow = false
      this.smShow = false

    },
    smClick () {
      this.smShow = !this.smShow
      this.flag4 = !this.flag4
      this.flag1 = false
      this.flag2 = true
      this.flag3 = true
      this.hbbShow = false
      this.zhShow = false
      this.gmShow = false
    },
    //公告
    getNotice () {
      this.$http.post(this.$apiPath.getAnnouncementPC, {}).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          let gongGao = '';
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach((val, i) => {
              gongGao += (i + 1) + ' .' + val.summary + ' '
            })
            $('.li-item').html(gongGao)
          } else {
            this.hornShow = false
          }
        } else {
          this.hornShow = false
        }
      }).catch(err => { })
    },
    // 完善信息
    perfect () {
      this.$router.push({
        name: 'openAccount',
        params: {
          phone: this.$commonJs.getCookie('register-phone'),
          pass: this.$commonJs.getCookie('register-ps')
        }
      })
      document.title = '展恒基金-个人中心'
    }
  },
}
 </script>

<style lang="less">
// 导航
.navOne {
  background: #e9e9e9;
  .el-menu--horizontal > .el-menu-item {
    width: 130px;
    height: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 18px;
    color: #2a2a2a;
  }
  .el-menu.el-menu--horizontal {
    border: none;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    background: #246ead;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
    background: #246ead;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
}
// 交易
.tradingCenter {
  margin-top: 8px;
  &_title {
    position: relative;
    height: 45px;
    background: #e9e9e9;
    border-bottom: 1px solid #c8c8c8;
    .trade {
      width: 150px;
      height: 100%;
      line-height: 45px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      background: #246ead;
      border-right: 5px solid #fff;
    }
    .el-menu {
      position: absolute;
      left: 155px;
      top: 0;
      height: 45px;
      background: #e9e9e9;
    }
  }
}
.myassets {
  padding-bottom: 20px;
}
.assets {
  position: relative;
  height: 350px;
  border: 1px solid #c8c8c8;
  border-top: none;
  .assets_con {
    width: 100%;
    height: 265px;
    padding: 18px 0;
    .distribution {
      position: relative;
      width: 65%;
      height: 100%;
      &_words {
        position: relative;
        margin-left: 28px;
        color: #2a2a2a;
        font-size: 18px;
        font-weight: bold;
        z-index: 9999999;
      }
      &_detail {
        box-sizing: border-box;
        width: 37%;
        height: 100%;
        position: absolute;
        top: 6px;
        right: 40px;
        li {
          font-size: 20px;
          width: 100%;
          margin: 28px 0;
          text-align: left;
          color: #333;
          span {
            font-size: 20px;
            color: #2a2a2a;
            font-weight: bold;
          }
        }
      }
    }
    .dottedLine {
      width: 5px;
      height: 100%;
      box-sizing: border-box;
      border-left: 1px dashed #bfbfbf;
      border-right: 1px dashed #bfbfbf;
    }
    .coupon {
      width: calc(35% - 5px);
      height: 100%;
      box-sizing: border-box;
      padding: 20px 50px;
      // background: blue;
      .couponCard {
        width: 100%;
        height: 50%;
        // background: pink;
        .coupon1 {
          color: #246ead;
          font-size: 18px;
          font-weight: bold;
        }
        .coupon2 {
          color: #333;
          margin: 12px 0;
          li {
            display: inline-block;
          }
          li:nth-child(2) {
            position: absolute;
            left: 126px;
          }
        }
      }
    }
  }
  .assets_foot {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45px;
    line-height: 45px;
    background: #d3e2ef;
    // padding-left: 50px;
    .hornImg {
      position: absolute;
      top: 50%;
      left: 27px;
      transform: translateY(-50%);
    }
    // 公告
    .hornTit {
      position: absolute;
      width: 1000px;
      left: 60px;
    }
    .hornWords {
      position: absolute;
      width: 1080px;
      left: 100px;
      top: 0px;
      overflow: hidden;
      span {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
// 模块
.fundModule {
  height: 333px;
  border: 1px solid #c8c8c8;
  margin-top: 10px;

  .mod {
    position: relative;
    box-sizing: border-box;
    float: left;
    width: 25%;
    height: 100%;
    padding: 0 20px;
    border-right: 1px solid #c8c8c8;
    // cursor: pointer;
    .fundTol {
      margin-left: 15px;
      padding-bottom: 18px;
      color: #747474;
      font-size: 14px;
      border-bottom: 1px dashed #c8c8c8;
      span {
        margin-left: 20px;
        color: #000;
        font-size: 26px;
        font-weight: bold;
      }
    }
    .profitBox {
      margin-left: 15px;
      margin-top: 18px;
      color: #747474;
      font-size: 14px;
      li {
        margin-bottom: 20px;
        color: #747474;
        span {
          font-weight: bold;
        }
      }
    }
    .fundOperation {
      margin-left: 12px;
    }
    .open {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      color: #246ead;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
  .mod:hover,
  .active {
    // border: 3px solid #91b6d6;
    box-shadow: #91b6d6 0px 0px 9px;
    // background: #000;
  }
  li:last-child {
    border-right: none;
  }
}

.colorBlue {
  color: #246ead;
  font-weight: bold;
}

.noData {
  width: 194px;
  height: 194px;
  position: absolute;
  top: 35px;
  left: 139px;
}
.overdue {
  position: absolute;
  top: 33px;
  right: -20px;
}

//公告
.warp {
  // width: 8000px;
  width: 15000px;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        //   width: 3500px;
        width: 6000px;
        height: 45px;
        margin-right: 10px;
        line-height: 45px;
        text-align: center;
      }
    }
  }
}
.hbbEcharts {
  margin-top: 70px;
}
// 数据
.message_record {
  li {
    float: left;
    margin: 24px 50px 24px 0;
    color: #333;
    span {
      font-weight: bold;
    }
  }
}
</style>
